//accordion inner menu
export function innerMenu(event) {
    if ($(window).width() < 1023) {
        let element = $(event.target).closest('li');
        let elementLink = $(event.target).closest('a');
        if (element.hasClass('has-sub')) {
            event.preventDefault();
            if (element.hasClass('active')) {
                //sub dropdown is closed
                element.removeClass('open active');
                element.find('.arrow').css({ 'transform': '' });
            } else {
                //sub dropdown is open
                jQuery('.main-nav > li').removeClass('open active');
                element.addClass('open active');
                element.siblings('li').removeClass('open');
                element.siblings('li').find('li').removeClass('open');
                element.find('.arrow').css({ 'transform': 'rotate(-180deg)' });
            }
        
            if (element.hasClass('open active')) {
                elementLink.attr('aria-expanded', true);
            } else {
                elementLink.attr('aria-expanded', false);
            }
        }
    }
}

export function createMenu() {

    //toggle the mobile menu hamburger
    $(".hamburger-menu").on("click", function (e) {
        e.preventDefault();
        $(".menu").toggleClass("menu-open");
        $(".menu-wrapper .bar").toggleClass("animate");
        $("body").toggleClass("fixed");
        if ($(".hamburger-menu").attr("aria-expanded") === "false") {
            $(".hamburger-menu").attr("aria-expanded", "true");
            $(".hamburger-menu").attr("aria-label", "click to close menu");
        } else {
            $(".hamburger-menu").attr("aria-expanded", "false");
            $(".hamburger-menu").attr("aria-label", "click to open menu");
        }
    })


    //opens submenu dropdown
    // $('.primary-nav .has-sub').on("mouseenter", function (e) {
    //     openDropDown($(this))
    // });

    //closes submenu dropdown
    // $('.primary-nav .has-sub').on("mouseleave", function (e) {
    //     closeDropDown($(this));
    // });

    //open and close drop down on click
    $('.primary-nav').find(".has-sub").on("click", function (e) {
        e.stopPropagation();
        if ($(this).hasClass("open")) {
            closeDropDown($(this))
        } else {
            openDropDown($(this))
        }
    });

    $('.primary-nav .has-sub').on('keydown', function (e) {
        if(e.which == 13 || e.which == 32){
            if(!$(e.target).attr('href')){
                e.preventDefault();
            }
            $(this).click();
        }
    });
}
function openDropDown(subject) {
    if ($(window).width() > 1023) {
        $(subject).find('.sub-menu').stop(true,false).slideDown();
        $(subject).addClass("open")
        $(subject).find('.arrow').css({ 'transform': 'rotate(-180deg)' });
    }
}

function closeDropDown(subject) {
    if ($(window).width() > 1023) {
        $(subject).find('.sub-menu').stop(true,false).slideUp();
        $(subject).removeClass("open");
        $(subject).find('.arrow').css({ 'transform': '' });
    }
}
export function addActiveDesktop(e) {
    if (jQuery(window).width() > 1280) {
        e.preventDefault();
        e.stopPropagation();
        if (jQuery(e.target).hasClass('has-sub')) {
            jQuery(e.target).children('a').attr('aria-expanded', false);
        }
        openDropDown(jQuery(e.target));
    }
}
export function removeActiveDesktop(e) {
    if (jQuery(window).width() > 1280) {
        e.preventDefault();
        e.stopPropagation();
        if (jQuery(e.target).hasClass('has-sub')) {
            jQuery(e.target).children('a').attr('aria-expanded', false);
        }
        closeDropDown(jQuery(e.target));
    }
}

